import React from 'react';
import { useTranslation } from 'react-i18next';

interface AddDeductionButtonProps {
    onClick: () => void;
    className?: string;
}

const AddDeductionButton: React.FC<AddDeductionButtonProps> = ({ onClick, className = '' }) => {
    const { t } = useTranslation();

    return (
        <button 
            className={`add-deduction-btn ${className}`}
            onClick={onClick}
        >
            <span className="add-deduction-btn__icon">+</span>
            <span className="add-deduction-btn__text">{t('ADD_DEDUCTION') || 'Add Deduction'}</span>
        </button>
    );
};

export default AddDeductionButton;
